import {
  SessionPickerList as SessionPickerListView,
  useLinkableContextItems,
  type SessionPickerListProps,
} from '@heidi/agents';

/** Binds the session picker to the app's linkable-context rows. */
export const SessionPickerList = (props: SessionPickerListProps): JSX.Element => (
  <SessionPickerListView {...props} useLinkableItems={useLinkableContextItems} />
);
